<template>
    <div class="base-form-div">
        <el-form size="mini" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="父节点" prop="flpid">
                <el-input :disabled="true" v-model="pidname"></el-input>
            </el-form-item>
            <el-form-item label="舰船型号" prop="type">
                <el-input :disabled="true" v-model="ruleForm.type"></el-input>
                <!-- <el-select v-model="ruleForm.cdid" placeholder="请选择字典类型">
                    <el-option v-for="item in typeOptions" :key="item.key" :label="item.label" :value="item.key">
                    </el-option>
                </el-select> -->
            </el-form-item>
            <el-form-item label="位置名称" prop="flname">
                <el-input placeholder="请输入位置名称" v-model="ruleForm.flname"></el-input>
            </el-form-item>
            <div class="form-bottom">
                <el-button class="base-button" size="mini" type="primary" @click="submitForm('ruleForm')">创建</el-button>
                <el-button class="base-button" size="mini" @click="resetForm('ruleForm')">重置</el-button>
            </div>
        </el-form>
    </div>
</template>
<script>
import { createGzwz } from "@/api/equipmentDic/index.js"
export default {
    props: ["subData"],
    data() {
        return {
            typeOptions: [{
                key: '1412261015343639',
                label: '052C'
            }, {
                key: '1504012158172549',
                label: '054A'
            }],
            pidname:"",
            ruleForm: {
                type: "",
                flpid: "",
                flname: ""
            },
            rules: {
                flname: [
                    { required: true, message: "请输入位置名称", trigger: "blur" },
                    {
                        min: 2,
                        max: 50,
                        message: "长度在 2 到 50 个字符",
                        trigger: "blur",
                    },
                ],
                cdid: [
                    { required: true, message: "请选择字典类型", trigger: "change" },
                ]
            },
        };
    },
    methods: {
        submitForm(formName) {
            console.log(this.ruleForm);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    createGzwz(this.ruleForm).then(() => {
                        this.$message({
                            message: "添加成功",
                            type: "success",
                        });
                        this.$bus.$emit("faultLocation-list");
                        this.$parent.close();
                    });
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
    },
    created() {
        this.ruleForm.flpid = this.subData.model.split('_')[1];
        this.pidname = this.subData.name;
        this.ruleForm.type=this.subData.rootType;
    },
    mounted() { },
};
</script>
<style>
.form-bottom {
    margin-bottom: 0 !important;
    text-align: center;
}

.el-input-number {
    width: 100%;
}
</style>